export const APIConfig = {
  gms: 'gms-api',
  sso: 'sso'
} as const
